import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';

import { Position, openPositionsBunja } from '@flipster/r230522/original/position';
import Num from '@flipster/utils/num';

import { createPositionByIdOrDismissAtom } from '../../../utils/position-or-dismiss';

export function useProfitBoost(symbol: string, positionId: Position['positionId']) {
  const { openPositionsAtom } = useBunja(openPositionsBunja);

  const positionAtom = useMemo(
    () => createPositionByIdOrDismissAtom({ openPositionsAtom, symbol, positionId }),
    [openPositionsAtom, symbol, positionId],
  );
  const position = useAtomValue(positionAtom);
  const profitBoost = position.buyableBoosts[0];

  // 실시간으로 소켓을 통해 값을 가져와야하기 때문에 positionId만 prop으로 받아오도록 함
  const cost = profitBoost?.costDiscounted ?? profitBoost?.cost;

  const discountRate =
    profitBoost?.costDiscounted && profitBoost?.cost
      ? Num(1)
          .minus(Num(profitBoost.costDiscounted).div(Num(profitBoost.cost)))
          .toNumber()
      : 0;
  const percent = discountRate ? Num(discountRate).multipliedBy(100).toFixed(0) : undefined;

  return {
    profitBoost,
    cost,
    discountRate,
    percent,
    position,
  };
}
